import * as React from "react";

export interface PaymentGroupShowMoreCtaContextValue {
    paymentGroupShowMoreCtaState: {
        [key: string]: boolean;
    };
    setPaymentGroupShowMoreCtaState: (groupType: string, show: boolean) => void;
}

export const PaymentGroupShowMoreCtaContext = React.createContext<PaymentGroupShowMoreCtaContextValue>({
    paymentGroupShowMoreCtaState: {},
    setPaymentGroupShowMoreCtaState: () => void 0,
});

if (__DEV__) {
    PaymentGroupShowMoreCtaContext.displayName = "PaymentGroupShowMoreCtaContext";
}
